export default {
      id: "search-usage",
      viewBox: "0 0 12 12",
      url: "../../assets/" + "sprite.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }